var map = {
	"./cptgb-1-en.png": "3377",
	"./cptgb-1.png": "2af5",
	"./cptgb-2-en.png": "af82",
	"./cptgb-2.png": "e47f",
	"./cptgb-3-en.png": "1821",
	"./cptgb-3.png": "6115",
	"./cptgb-4-en.png": "6ebd",
	"./cptgb-4.png": "96cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d05";